
import { Route } from "react-router-dom";
import ProtectedRoute from "./protectedRouter";
import TemplateAdmin from "../admin/template/templateAdmin";
import ViewFarmacovigilancia from "../admin/departamentos/dftec/farmacovigilancia";
import Notificacoes from "../admin/departamentos/dftec/farmacovigilancia/notificacoes";
import ChangeStatusFarmacoviligancia from "../admin/departamentos/dftec/farmacovigilancia/changeStatusFarmacoviligancia";

const dftec = ["DFTEC", "CNP", "DG"];

const dftecRoutes = ({ user }) => [

  // farmacovigilancia
  <Route key="dftec1" element={<ProtectedRoute departamentoAutorizado={dftec} isAuthenticated={user} redirectPath={'/login'} > <TemplateAdmin element={<Notificacoes />} /> </ProtectedRoute>} path="/admin/farmacovigilancia/notificacoes/:status" />,
  <Route key="dftec2" element={<ProtectedRoute departamentoAutorizado={dftec} isAuthenticated={user} redirectPath={'/login'} > <TemplateAdmin element={<ViewFarmacovigilancia />} /> </ProtectedRoute>} path="/admin/farmacovigilancia/view/notificacao/:id" />,
  <Route key="dftec3" element={<ProtectedRoute departamentoAutorizado={dftec} isAuthenticated={user} redirectPath={'/login'} > <TemplateAdmin element={<ViewFarmacovigilancia element={<ChangeStatusFarmacoviligancia />} />} /> </ProtectedRoute>} path="/admin/dftec/farmacovigilancia/:action/:status/:id" />,
  
];

export default dftecRoutes;